// src/Router.js
import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { sendNotification } from "./utils/notifications";
import Layout from "./components/Layout";
import ProtectedRoute from "./components/ProtectedRoute";

// صفحات الواجهة الرئيسية
import HomePage          from "./pages/HomePage";
import Login             from "./pages/Login";
import Signup            from "./pages/Signup";
import Dashboard         from "./pages/Dashboard";
import Orders            from "./pages/Orders";
import NotificationsPage from "./pages/NotificationsPage";
import NotFound          from "./pages/NotFound";
import PrivacyPolicy from "./pages/PrivacyPolicy";

// صفحات المطعم
import RestaurantLogin         from "./restaurant/pages/RestaurantLogin";
import RestaurantDashboard     from "./restaurant/pages/RestaurantDashboard";
import NewOrder                from "./restaurant/pages/NewOrder";
import RestaurantOrders        from "./restaurant/pages/RestaurantOrders";
import OrderDetails            from "./restaurant/pages/OrderDetails";
import Wallet                  from "./restaurant/pages/Wallet";
import Reports                 from "./restaurant/pages/Reports";
import Settings                from "./restaurant/pages/Settings";
import RestaurantNotifications from "./restaurant/pages/RestaurantNotifications";
import RestaurantChat from './restaurant/pages/RestaurantChat';

// صفحات الإدارة
import AdminOrders            from "./admin/AdminOrders";
import DriverManagement       from "./admin/DriverManagement";
import RestaurantManagement   from "./admin/RestaurantManagement";
import ToolsPage              from "./admin/pages/ToolsPage";
import DriverTracking         from "./pages/DriverTracking";
import DriverTrackingReports  from "./pages/DriverTrackingReports";
import DriverTrackingHistory  from "./pages/DriverTrackingHistory";
import AdminMessages          from "./pages/AdminMessages";
import AdminChat              from "./pages/AdminChat";
import SendMessageToDriver    from "./pages/SendMessageToDriver";
import AdminReports           from "./admin/pages/AdminReports";
import AdminSettings          from "./admin/pages/AdminSettings";
import AdminReportsMain       from "./admin/pages/AdminReportsMain";
import AdminReportsRestaurants from "./admin/pages/AdminReportsRestaurants";
import AdminReportsDrivers    from "./admin/pages/AdminReportsDrivers";
import AdminReportsFinance    from "./admin/pages/AdminReportsFinance";
import OperationsOrdersReport from "./admin/pages/OperationsOrdersReport";
import FinanceReports         from "./admin/pages/FinanceReports";
import AdminDatabaseManager   from "./pages/AdminDatabaseManager";
import MonitorChat from './pages/MonitorChat'; 
import AdminMonitorChatList from './pages/AdminMonitorChatList';
// صفحات العميل
import CustomerOrders from "./customer/pages/CustomerOrders";

// صفحات السائق
import DriverDashboard from "./driver/pages/DriverDashboard";
import DriverOrders    from "./driver/pages/DriverOrders";
import DriverProfile   from "./driver/pages/DriverProfile";

import FAQ from './pages/FAQ';
import ContactUs from './pages/ContactUs';
import TermsOfService from './pages/TermsOfService';
import ReturnPolicy from './pages/ReturnPolicy';
import AboutUs from './pages/AboutUs';
import UserGuide from './pages/UserGuide';
import Features from './pages/Features';
import Pricing from './pages/Pricing';
import DeleteAccount from './pages/DeleteAccount';
const AppRouter = () => {
  useEffect(() => {
    // إرسال إشعار عند بدء التطبيق (اختياري)
    const userRole = localStorage.getItem("userRole");
    if (userRole === "admin") {
      sendNotification("admin", "system", "🚀 التطبيق يعمل بنجاح!");
    }
  }, []);

  return (
    <Router>
      <Layout>
        <Routes>

          {/* صفحات عامة */}
          <Route path="/"           element={<HomePage />} />
          <Route path="/login"      element={<Login />} />
          <Route path="/signup"     element={<Signup />} />
          <Route path="/dashboard"  element={<Dashboard />} />
          <Route path="/orders"     element={<Orders />} />
          <Route path="/notifications" element={<NotificationsPage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />  {/* إضافة هذا السطر */}
          <Route path="/delete-account" element={<DeleteAccount />} />

          {/* ✅ الصفحات الجديدة */}
          <Route path="/faq" element={<FAQ />} />
          <Route path="/contact" element={<ContactUs />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
          <Route path="/return-policy" element={<ReturnPolicy />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/user-guide" element={<UserGuide />} />
          <Route path="/features" element={<Features />} />
          <Route path="/pricing" element={<Pricing />} />
          {/* صفحات المطعم */}
          <Route path="/restaurant/login" element={<RestaurantLogin />} />
          <Route path="/restaurant/dashboard" element={
            <ProtectedRoute role="restaurant">
              <RestaurantDashboard />
            </ProtectedRoute>
          }/>
          <Route path="/restaurant/orders/new" element={
            <ProtectedRoute role="restaurant">
              <NewOrder />
            </ProtectedRoute>
          }/>
          <Route path="/restaurant/orders" element={
            <ProtectedRoute role="restaurant">
              <RestaurantOrders />
            </ProtectedRoute>
          }/>
          <Route path="/restaurant/orders/:id" element={
            <ProtectedRoute role="restaurant">
              <OrderDetails />
            </ProtectedRoute>
          }/>
          <Route path="/restaurant/wallet" element={
            <ProtectedRoute role="restaurant">
              <Wallet />
            </ProtectedRoute>
          }/>
          <Route path="/restaurant/chat" element={
          <ProtectedRoute role="restaurant">
          <RestaurantChat />
          </ProtectedRoute>
          } />
          <Route path="/restaurant/reports" element={
            <ProtectedRoute role="restaurant">
              <Reports />
            </ProtectedRoute>
          }/>
          <Route path="/restaurant/settings" element={
            <ProtectedRoute role="restaurant">
              <Settings />
            </ProtectedRoute>
          }/>
          <Route path="/restaurant/notifications" element={
            <ProtectedRoute role="restaurant">
              <RestaurantNotifications />
            </ProtectedRoute>
          }/>

          {/* صفحات الإدارة */}
          <Route path="/admin/orders" element={
            <ProtectedRoute role="admin">
              <AdminOrders />
            </ProtectedRoute>
          }/>
          <Route path="/admin/driver-management" element={
            <ProtectedRoute role="admin">
              <DriverManagement />
            </ProtectedRoute>
          }/>
          <Route path="/admin/restaurant-management" element={
            <ProtectedRoute role="admin">
              <RestaurantManagement />
            </ProtectedRoute>
          }/>
          <Route path="/admin/driver-tracking" element={
            <ProtectedRoute role="admin">
              <DriverTracking />
            </ProtectedRoute>
          }/>
          <Route path="/admin/driver-tracking-reports" element={
            <ProtectedRoute role="admin">
              <DriverTrackingReports />
            </ProtectedRoute>
          }/>
          <Route path="/admin/driver-tracking-history" element={
            <ProtectedRoute role="admin">
              <DriverTrackingHistory />
            </ProtectedRoute>
          }/>
          <Route path="/admin/messages" element={
            <ProtectedRoute role="admin">
              <AdminMessages />
            </ProtectedRoute>
          }/>
          <Route path="/admin/send-driver-message" element={
            <ProtectedRoute role="admin">
              <SendMessageToDriver />
            </ProtectedRoute>
          }/>
          <Route path="/admin/chat" element={
          <ProtectedRoute role="admin">
          <AdminChat />
          </ProtectedRoute>
          } />
          <Route path="/admin/chat/:restaurantId" element={
            <ProtectedRoute role="admin">
              <AdminChat />
            </ProtectedRoute>
          }/>

          <Route path="/admin/chat/:driverId" element={
            <ProtectedRoute role="admin">
              <AdminChat />
            </ProtectedRoute>
          }/>
          <Route path="/admin/tools" element={
            <ProtectedRoute role="admin">
              <ToolsPage />
            </ProtectedRoute>
          }/>
          <Route path="/admin/monitor" element={
            <ProtectedRoute role="admin">
            <AdminMonitorChatList />
            </ProtectedRoute>
          } />

          <Route path="/admin/monitor/:chatId" element={
            <ProtectedRoute role="admin">
            <MonitorChat />
            </ProtectedRoute>
            } />


          <Route path="/admin/reports" element={
            <ProtectedRoute role="admin">
              <AdminReports />
            </ProtectedRoute>
          }/>
          <Route path="/admin/reports/main" element={
            <ProtectedRoute role="admin">
              <AdminReportsMain />
            </ProtectedRoute>
          }/>
          <Route path="/admin/reports/restaurants" element={
            <ProtectedRoute role="admin">
              <AdminReportsRestaurants />
            </ProtectedRoute>
          }/>
          <Route path="/admin/reports/drivers" element={
            <ProtectedRoute role="admin">
              <AdminReportsDrivers />
            </ProtectedRoute>
          }/>
          <Route path="/admin/reports/finance" element={
            <ProtectedRoute role="admin">
              <AdminReportsFinance />
            </ProtectedRoute>
          }/>
          <Route path="/admin/reports/operations/orders" element={
            <ProtectedRoute role="admin">
              <OperationsOrdersReport />
            </ProtectedRoute>
          }/>
          <Route path="/admin/reports/finance/revenue" element={
            <ProtectedRoute role="admin">
              <FinanceReports />
            </ProtectedRoute>
          }/>
          <Route path="/admin/database" element={
            <ProtectedRoute role="admin">
              <AdminDatabaseManager />
            </ProtectedRoute>
          }/>
          <Route path="/admin/settings" element={
            <ProtectedRoute role="admin">
              <AdminSettings />
            </ProtectedRoute>
          }/>

          {/* صفحات العميل */}
          <Route path="/customer/orders" element={
            <ProtectedRoute role="customer">
              <CustomerOrders />
            </ProtectedRoute>
          }/>

          {/* صفحات السائق */}
          <Route path="/driver/dashboard" element={
            <ProtectedRoute role="driver">
              <DriverDashboard />
            </ProtectedRoute>
          }/>
          <Route path="/driver/orders" element={
            <ProtectedRoute role="driver">
              <DriverOrders />
            </ProtectedRoute>
          }/>
          <Route path="/driver/profile" element={
            <ProtectedRoute role="driver">
              <DriverProfile />
            </ProtectedRoute>
          }/>

          {/* صفحة 404 */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Layout>
    </Router>
  );
};

export default AppRouter;
